/**
 * Best display name for a user: full name, then either name part, then email.
 *
 * Its own module so route definitions (breadcrumbs) can import it without pulling
 * `UserDetailHeader`, its antd menus and the phone formatter into the boot graph.
 */
export function getUserDisplayName(user: {
    firstName: string | null | undefined;
    lastName: string | null | undefined;
    email: string;
}) {
    if (user.firstName && user.lastName) {
        return `${user.firstName} ${user.lastName}`;
    }
    return user.firstName || user.lastName || user.email;
}
